import React from 'react';
import './App.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CoachSection from './components/CoachSection';
import CoachingPurpose from './components/CoachingPurpose';
import ChampionshipSection from './components/ChampionshipSection';
import GenerationsSection from './components/GenerationsSection';
import CommunitySection from './components/CommunitySection';
import TipsSection from './components/TipsSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <HeroSection />
      <CoachSection />
      <CoachingPurpose />
      <ChampionshipSection />
      <GenerationsSection />
      <CommunitySection />
      <TipsSection />
      <Footer />
    </div>
  );
}

export default App;
